export type DevBuildOverlay = {
  buildId: string | null;
  bundleIdentifier: string;
  hide(): Promise<void>;
  setStamp(text: string, outdated: boolean, accessibilityLabel: string): Promise<void>;
  /** Clears the suppression `hide` sets, so a later `setStamp` can show the window again. */
  show(): Promise<void>;
};

export const nativeDevBuildOverlay: DevBuildOverlay | null = null;
